import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-actions",
  "use": "foquz-icon-actions-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-actions\"><path d=\"M1 4h9m0 0a2 2 0 104 0 2 2 0 00-4 0zm4 7H5m0 0a2 2 0 11-4 0 2 2 0 014 0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol